export default "__VITE_ASSET__5dAC99h9__"